import React from 'react';
import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';

import { VpButton, VpIcon } from '../.';

export const VpAlertBigIcon = ({ severity, icon, onClick, children, ...rest }) => {
  return (
    <Alert
      severity={severity}
      sx={{ alignItems: 'center' }}
      icon={<VpIcon size={45} icon={icon} />}
      {...rest}
      action={
        <VpButton sx={{ marginRight: '8px' }} onClick={onClick} variant="outlined">
          Cancel selection mode
        </VpButton>
      }
    >
      {children}
    </Alert>
  );
};

VpAlertBigIcon.propTypes = {
  severity: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

export default VpAlertBigIcon;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpAlertBigIcon/VpAlertBigIcon.jsx